<div class="communication-log-modal">
  <div class="modal-header">
    <div class="text-center">
      <h5>Communication Details</h5>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <!-- Email Box -->
    <div *ngIf="email" class="box email-box">
      <h5 class="mb-4">Email</h5>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>To:</strong></div>
            <div class="col">
              <span>{{ email.toEmailAddress }}</span>&nbsp;&nbsp;
              <span class="text-warning" *ngIf="email.isConsignorContactDeleted === true">(This Consignor Contact has been deleted)</span>
            </div>
          </div>
          <hr />
        </div>
        <div class="col-md-12" *ngIf="email.subject">
          <div class="row">
            <div class="col-2"><strong>Subject:</strong></div>
            <div class="col"><span>{{ email.subject }}</span></div>
          </div>
          <hr />
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>Message:</strong></div>
            <div class="col"><span [innerHTML]="email.emailBodyText | safeHtml"></span></div>
          </div>
          <hr />
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>Email Status:</strong></div>
            <div class="col">
              <div class="row" *ngFor="let event of email.events">
                <div class="col-2">
                  <span class="study-status-box {{getColorClass(event)}}">
                    {{ event.eventName }}

                  </span>
                </div>
                <div class="col">
                  {{ event.eventDate | date:'medium' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SMS Box -->
    <div *ngIf="sms" class="box email-box">
      <h5 class="mb-4">SMS</h5>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>To:</strong></div>
            <div class="col"><span>{{ sms.toMobileNumber }}</span></div>
          </div>
          <hr />
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>SMS:</strong></div>
            <div class="col"><span>{{ sms.smsBodyText }}</span></div>
          </div>
          <!--<hr />-->
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>Date Sent:</strong></div>
            <div class="col">
              <div class="row">
                <div class="col">
                  {{ sms.sentDate | date:'medium' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>SMS Status:</strong></div>
            <div class="col">
              <div class="row" *ngFor="let event of sms.smsEvents">
                <div class="col-2">
                  <span class="sms-status-box {{getSMSColorClass(event)}}">
                    {{ event.status }}
                  </span>
                </div>
                <div class="col">
                  {{ event.dateSent | date:'medium' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- WhatsApp Box -->
    <div *ngIf="whatsapp" class="box email-box">
      <h5 class="mb-4">WhatsApp</h5>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>To:</strong></div>
            <div class="col"><span>{{ whatsapp.toMobileNumber }}</span></div>
          </div>
          <hr />
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>WhatsApp:</strong></div>
            <div class="col"><span>{{ whatsapp.smsBodyText }}</span></div>
          </div>
          <!--<hr />-->
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>Date Sent:</strong></div>
            <div class="col">
              <div class="row">
                <div class="col">
                  {{ whatsapp.sentDate | date:'medium' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-2"><strong>WhatsApp Status:</strong></div>
            <div class="col">
              <div class="row" *ngFor="let event of whatsapp.whatsAppEvents">
                <div class="col-2">
                  <span class="whatsapp-status-box {{getWhatsAppColorClass(event)}}">
                    {{ event.status }}
                  </span>
                </div>
                <div class="col">
                  {{ event.dateSent | date:'medium' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer justify-content-between">

    </div>
  </div>
</div>
